import React from "react";
import { Paper, Text, Group, Box } from "@mantine/core";
import { IconHome } from "@tabler/icons-react";

// Color constants
const COLOR_BACKGROUND_LIGHT = "#f8f9fa";
const COLOR_BORDER_LIGHT = "#e9ecef";
const COLOR_ICON_GRAY = "#6c757d";

const WebsiteCustomizeOption: React.FC = () => {
  // TODO: Nick to create a one-click form submission for line 19-33
  return (
    <Paper
      p="md"
      style={{
        backgroundColor: COLOR_BACKGROUND_LIGHT,
        border: `1px solid ${COLOR_BORDER_LIGHT}`,
        borderRadius: "8px",
      }}
    >
      <Group align="flex-start" gap="md">
        <IconHome size={24} color={COLOR_ICON_GRAY} />
        <Box>
          <Text size="lg" fw={600} mb="xs">
            Looking to further customize your website?
          </Text>
          <Text c="dimmed">
            Schedule a session with one of our design specialists to receive a
            custom quote, reach out to{" "}
            <Text
              component="a"
              href="mailto:contact@getpagoda.com"
              c="blue"
              td="underline"
            >
              contact@getpagoda.com
            </Text>{" "}
            if you're interested!
          </Text>
        </Box>
      </Group>
    </Paper>
  );
};

export default WebsiteCustomizeOption;
